import { css } from '@emotion/css';

import { colors } from '@editor2/styles/colors';

export const questionBlockLabel = css`
	margin-bottom: 10px;
	color: ${colors.labelText};
	font-size: 12px;
`;

export const questionBlock = css`
	border: 1px solid ${colors.border};
	border-radius: 4px;
	margin-bottom: 10px;

	.header {
		display: flex;
		flex-direction: column;
		padding: 10px 16px;
		color: #495057;
		border-radius: 4px;
		background-color: white;
	}

	.title {
		display: flex;
		justify-content: space-between;
	}

	.preview {
		font-size: 12px;
		color: ${colors.infoText};
	}

	.header.expanded {
		border-bottom: 1px solid ${colors.border};
		background-color: ${colors.background};
		border-bottom-left-radius: 0;
		border-bottom-right-radius: 0;
	}

	.collapseIcon {
		transition-duration: 500ms;
	}

	.collapseIconRotate {
		transform: rotate(-90deg);
		transition-duration: 500ms;
	}

	.collapseIcon,
	.collapseIconRotate,
	.deleteQuestionIcon {
		margin-left: 10px;
		:hover {
			cursor: pointer;
		}
	}

	.body {
		padding: 16px;
		color: ${colors.mainText};
	}
`;

export const mcQuestionStyle = css`
	.CodeMirror {
		padding: 6px 12px;
		font-size: 16px !important;
		font-family: inherit !important;
	}

	.choice {
		margin-top: 30px;
		position: relative;

		.choiceGroup {
			flex-wrap: nowrap;
		}

		.input-group-text {
			border-bottom-left-radius: 0;
			border-bottom: none;
			background-color: ${colors.background};
		}

		.CodeMirror {
			border-radius: unset;
			border-top-right-radius: 4px;
		}
	}

	.question-text {
		border-bottom-right-radius: unset;
		font-weight: 600;
	}

	.rejoinder {
		display: flex;
		background-color: ${colors.background};
		border: 1px solid #ced4da;
		border-top: none;

		.draggableBlock {
			width: 39px;
			display: flex;
			align-items: center;
			justify-content: center;

			svg {
				width: 15px;
			}
		}

		.CodeMirror {
			font-size: 14px !important;
			border-radius: unset;
			border: none;
			border-left: 1px solid #ced4da;
		}
	}

	.deleteChoiceIcon {
		position: absolute;
		top: 4px;
		right: 4px;
		color: #ced4da;

		:hover {
			color: ${colors.hoverText};
		}
	}

	.addChoiceButton {
		margin-top: 15px;
		font-size: 14px;
		border: none;

		:hover {
			color: ${colors.mainText};
			border-color: ${colors.border};
			background-color: ${colors.background};
		}

		svg {
			margin-right: 5px;
		}
	}
`;
